import { ConfigType } from 'dayjs'
import { ICallOutHistory } from 'legacy/lut/classes/models/ICallOutHistory'
import { ICoverage } from 'legacy/lut/classes/models/ICoverage'
import { IFormComments } from 'legacy/lut/classes/models/IFormComments'
import { IFormDropdowns } from 'legacy/lut/classes/models/IFormDropdowns'
import { IFormMyPartnerSet } from 'legacy/lut/classes/models/IFormMyPartnerSet'
import { IFormPartners } from 'legacy/lut/classes/models/IFormPartners'
import { IFormPartnerSearchCache } from 'legacy/lut/classes/models/IFormPartnerSearchCache'
import { IFormPartnersExt } from 'legacy/lut/classes/models/IFormPartnersExt'
import { ITab } from 'legacy/lut/classes/models/ITab'
import { create as createProduct, TModel as TProduct } from 'legacy/lut/classes/models/Product'
import { IAnalysis, IAnalysisSections } from 'legacy/lut/classes/services/api/AnalysisApi'
import { IBusinessProfileIcon } from 'legacy/lut/classes/services/api/BusinessProfileApi'
import { ICallOutFetchResult, ICallOutSelect } from 'legacy/lut/classes/services/api/CallOutApi'
import { IPreferredDistributors } from 'legacy/lut/classes/services/api/PreferredDistributorsApi'
import { IPricingExt } from 'legacy/lut/classes/services/api/PricingApi'
import { IRegistrationDataFetchResult } from 'legacy/lut/classes/services/api/RegistrationDataApi'
import { ISharesOfBusiness } from 'legacy/lut/classes/services/api/SharesOfBusinessApi'
import { ISelectedPartner, ISelectedRequest } from 'legacy/lut/classes/services/PartnerStoreService'
import { IProductType } from 'legacy/lut/classes/services/PromotionService'
import { IPromotionList, IPromotionType } from 'legacy/shared/classes/services/api/PromotionApi'

import { jbpPartnerAccessInitialState } from 'clickNgo/entities/partner/api/getPartnerAccess'
import { IDataProviderSort } from 'core-components/types'
import { dayjsUTC } from 'core/classes/helpers/DateHelper'
import { IDatabase } from 'core/classes/helpers/store/Interfaces'
import { ICountry, IHPOrg, IReference } from 'core/classes/models/IReference'
import { TInitialState } from 'core/store'
import settings from 'src/config/settings'

import { IFormCategories } from '../classes/models/IFormCategories'
import { IFormCompanyDetails, IFormPartnerDetails } from '../classes/models/IFormCompanyDetails'
import { IFormLeadAbout } from '../classes/models/IFormLeadAbout'
import { IFormPOSImages } from '../classes/models/IFormPOSImages'
import { IFormToDoFlags } from '../classes/models/IFormToDoFlags'
import { IFormP360State } from '../classes/models/partner360/IFormP360State'

export interface ICallOutCollection {
  outcomes: ICallOutSelect[]
  reasons: ICallOutSelect[]
  promotions: ICallOutSelect[]
  history: ICallOutFetchResult
}

export interface ISharesOfBusinessCollection {
  sharesOfBusiness: ISharesOfBusiness[]
}

export interface IAnalysisWidgetCollection {
  partnerLandscape: IAnalysis[]
  partnerLandscapeSections: IAnalysisSections[]
  swotAnalysis: IAnalysis[]
  swotAnalysisSections: IAnalysisSections[]
}

export interface IPreferredDistributorsCollection {
  preferredDistributors: IPreferredDistributors[]
}

export interface IBusinessProfileCollection {
  regDashboard: any[]
  relationship: IBusinessProfileIcon[]
  changeMindset: IBusinessProfileIcon[]
  roles: IBusinessProfileIcon[]
  status: IBusinessProfileIcon[]
  seniority: any[]
  competitors: IBusinessProfileIcon[]
}

export interface IMasterDataCollection {
  partnerCodes: any[]
  registrations: IRegistrationDataFetchResult
  selectedPartner: string // selected partner at the partners list on master data
  filterPartner: string // selected partner at the tab (can be only HQ)
}

export interface IPricingCollection {
  pricing: any[]
  pricingExt: IPricingExt[]
  pricingComments: any[]
}

export interface IPromotionFilters {
  intersectionDate: ConfigType
  culture?: string
  promotionType?: number | null
  productTypeId?: string
  searchQuery?: string
}

export const defaulIPartnerTabs =
  settings.appIdentifier.id !== 'hpscoutso'
    ? ([
        {
          area: '1',
          name: 'Activation',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '2',
          name: 'Pricing & Quoting',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '6',
          name: 'Business Plan',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '3',
          name: 'Amplify Eligibility',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '12',
          name: 'Country Channel Dashboard',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '4',
          name: 'All Contacts',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '5',
          name: 'Master Data',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '7',
          name: 'Registration',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: 'BPRegStatusCheck',
          name: 'BP Registration Status Check',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '8',
          name: 'My View',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '9',
          name: 'Comments',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '11',
          name: 'HP Lead Sharing',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: 'Locator',
          name: 'Locator',
          enabled: true,
          roles: ['SuperAdmin'],
        },
        {
          area: '13',
          name: 'Contracts',
          enabled: true,
          roles: ['SuperAdmin'],
        },
      ] as ITab[])
    : ([
        {
          area: '5',
          name: 'Master Data',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '4',
          name: 'All Contacts',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '3',
          name: 'Amplify Eligibility',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '12',
          name: 'Country Channel Dashboard',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
          regions: ['EMEA'],
        },
        {
          area: '16',
          name: 'ThoughtSpot',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '14',
          name: 'Inventory Dashboard',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '2',
          name: 'Contracts',
          enabled: true,
          roles: ['SuperAdmin'],
        },
        {
          area: '15',
          name: 'Order management IDs',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
        {
          area: '7',
          name: 'Business Partner Registration',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
          regions: ['EMEA'],
        },
        {
          area: 'BPRegStatusCheck',
          name: 'BP Registration Status Check',
          enabled: true,
          roles: ['SuperAdmin', 'iPBM'],
        },
      ] as ITab[])

export enum StoreForms {
  partners = 'partners',
  partnersExt = 'partnersExt',
  dropdowns = 'dropdowns',
  myPartnerSet = 'myPartnerSet',
  comments = 'comments',
  partnerSearchCache = 'partnerSearchCache',
  myCoverage = 'myCoverage',
  callOutHistory = 'callOutHistory',
  company = 'company',
  partner = 'partner',
  metalocatorCategories = 'metalocatorCategories',
  partnerImages = 'partnerImages',
  leadAbout = 'leadAbout',
  toDoFlags = 'toDoFlags',
}

type BaseStructure = {
  partners: IFormPartners
  partnersExt: IFormPartnersExt
  dropdowns: IFormDropdowns
  myPartnerSet: IFormMyPartnerSet
  comments: IFormComments
  partnerSearchCache: IFormPartnerSearchCache
  myCoverage: ICoverage
  callOutHistory: ICallOutHistory
  company: IFormCompanyDetails
  partner: IFormPartnerDetails
  metalocatorCategories: IFormCategories
  partnerImages: IFormPOSImages
  leadAbout: IFormLeadAbout
  toDoFlags: IFormToDoFlags
}
export type ILookupForms = IDatabase<BaseStructure>
export const lookupForms: ILookupForms = {
  forms: {
    partners: {
      data: [] as IFormPartners[],
      queries: {},
    },
    partnersExt: {
      data: [] as IFormPartnersExt[],
      queries: {},
    },
    dropdowns: {
      data: [] as IFormDropdowns[],
      queries: {},
    },
    myPartnerSet: {
      data: [] as IFormMyPartnerSet[],
      queries: {},
    },
    comments: {
      data: [] as IFormComments[],
      queries: {},
    },
    partnerSearchCache: {
      data: [] as IFormPartnerSearchCache[],
      queries: {},
    },
    myCoverage: {
      data: [] as ICoverage[],
      queries: {},
    },
    callOutHistory: {
      data: [] as ICallOutHistory[],
      queries: {},
    },
    company: {
      data: [] as IFormCompanyDetails[],
      queries: {},
    },
    partner: {
      data: [] as IFormPartnerDetails[],
      queries: {},
    },
    metalocatorCategories: {
      data: [] as IFormCategories[],
      queries: {},
    },
    partnerImages: {
      data: [] as IFormPOSImages[],
      queries: {},
    },
    leadAbout: {
      data: [] as IFormLeadAbout[],
      queries: {},
    },
    toDoFlags: {
      data: [] as IFormToDoFlags[],
      queries: {},
    },
  },
}

interface IUserLevel {
  EntryId: any
  Email: string
  Level: number
}

type TTranslationMode = 'read' | 'edit'
export interface ITranslation {
  mode: TTranslationMode
  defaultLocale: IReference
  locale: IReference
  isDefaultLocale: boolean
}

export interface IReferenceCollection {
  countries: ICountry[]
  countriesCode: IReference[]
  languages: IReference[]
  locales: IReference[]
  organizations: IHPOrg[]
  salutations: IReference[]
  associativeLanguages: IReferenceAssociativeLanguage[]
}

export interface IReferenceAssociativeLanguage extends IReference {
  CountryCode: string
}
export interface IGroupReference extends IReference {
  parent: string
}

export const initialLookupState = {
  landingAccessState: {
    isWelcomeFlowShown: false, // is user already seen welcome flow and he pass it successfuly
    isWelcomeFlowEligible: false, // is user available to fetch data for welcome flow and see welcome flow
    isAllowed: false,
    isFetched: false,
    isLoading: false,
    type: null,
    landingPage: null as string | null,
  },
  jbpPartnerAccess: jbpPartnerAccessInitialState,
  uamAccess: {
    profileLink: '',
    accessType: '', // geo/account
    stRole: '',
  },
  // uamAccessDeniedUpdateProfileLink: '',
  // readWriteAccess: ReadWriteAccess.Readonly,
  callOutWidget: {
    outcomes: [],
    reasons: [],
    promotions: [],
    history: { items: [], total: 0 },
  } as ICallOutCollection,
  sharesOfBusinessWidget: {
    sharesOfBusiness: [],
  } as ISharesOfBusinessCollection,
  analysisWidget: {
    partnerLandscape: [],
    partnerLandscapeSections: [],
    swotAnalysis: [],
    swotAnalysisSections: [],
  } as IAnalysisWidgetCollection,
  partners: {
    isInit: false,
    selectedPartners: [] as ISelectedPartner[],
    selectedPartners360: [] as any,
    partnerTabs: { ...defaulIPartnerTabs },
    currentPartnerId: '' as string | undefined,
  },
  preferredDistributorsWidget: {
    preferredDistributors: [],
  } as IPreferredDistributorsCollection,
  businessProfileWidget: {
    regDashboard: [],
    relationship: [],
    changeMindset: [],
    roles: [],
    status: [],
    seniority: [],
    competitors: [],
  } as IBusinessProfileCollection,
  masterDataWidget: {
    partnerCodes: [],
    registrations: { items: [], total: 0 },
    selectedPartner: '',
    filterPartner: '',
  } as IMasterDataCollection,
  pricingWidget: {
    pricing: [],
    pricingExt: [],
    pricingComments: [],
  } as IPricingCollection,
  promotions: {
    productTypes: [] as IProductType[],
    promotionTypes: [] as IPromotionType[],
    view: 'long' as 'short' | 'long',
    filters: {
      intersectionDate: dayjsUTC(),
      promotionType: null,
      productTypeId: '',
      searchQuery: '',
      culture: '',
    } as IPromotionFilters,
    sort: [{ field: 'modelName', dir: 'asc' }] as IDataProviderSort[],
    search: '',
    loaders: {
      control: false,
      product: null as null | boolean,
      content: false,
    },
    list: [] as IPromotionList[],
    product: createProduct() as TProduct,
  },
  locatorCompletements: {} as { [partnerId: string]: number },
  searchResultContactId: '',
  activePartnerTab: {} as { [partnerId: string]: string },
  searchForms: {} as { [key: string]: IObjectAny | null },
  partner360: {
    hrChartOptions: [],
  } as IFormP360State,
  onboarding: {
    openedRequests: [] as ISelectedRequest[],
  },
  userPoints: null as number | null,
  userLevel: {
    EntryId: null,
    Email: '',
    Level: -1,
  } as IUserLevel,
  translation: {
    mode: 'read',
    defaultLocale: {
      name: 'English-Global',
      value: 'en',
    },
    locale: {
      name: 'English-Global',
      value: 'en',
    },
    isDefaultLocale: true,
  } as ITranslation,
  references: {
    countries: [],
    countriesCode: [],
    languages: [],
    locales: [],
    organizations: [],
    associativeLanguages: [],
    salutations: [],
  } as IReferenceCollection,
  enableRecorder: false,
  recorderCommand: {
    command: '',
    final: false,
  },
}

export type ILookupOldState = typeof initialLookupState
type IFullLookupState = { lookup: ILookupForms } & {
  lookupOld: ILookupOldState
}
export type ILookupState = TInitialState<IFullLookupState>
